import raveIf from '@magalu/rave/template/rave-if';
import raveExp from '@magalu/rave/template/rave-exp';
import encodedObjectParser from '@magalu/rave/parser/encoded-object-parser';
import numberParser from '@magalu/rave/parser/number-parser';
import uppercaseParser from '@magalu/rave/parser/uppercase-parser';
import arrayShiftParser from '@magalu/rave/parser/array-shift-parser';

export const getComponents = props => ({
    'header-button-0': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        as: `a`,
        href: `#main-content`,
        label: `Pular para o conteudo principal`,
        className: `sr-only focus:not-sr-only focus:absolute focus:left-md focus:top-md focus:z-[9999]`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-preconnect-1': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://a-static.mlcdn.com.br`,
          `https://www.datadoghq-browser-agent.com`,
          `https://www.googletagmanager.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-preconnect-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-google-tag-manager-2': {
      name: `GoogleTagManager`,
      from: `@magalu/ecomm-components/rave/scripts/GoogleTagManager`,
      props: {
        id: `GTM-N9NRZNKX`,
        strategy: `beforeInteractive`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-google-tag-manager-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-3': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-script-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-4': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-all-in-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-5': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-criteo-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-bing-6': {
      name: `Bing`,
      from: `@magalu/ecomm-components/rave/scripts/Bing`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-bing-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-cookie-security-7': {
      name: `CookieSecurity`,
      id: `header-cookie-security-7`,
      from: `@magalu/ecomm-components/rave/scripts/CookieSecurity`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      props: {
        scriptId: `cookieSecurity`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-tik-tok-8': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-tik-tok-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-9': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-rtbhouse-9`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-10': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-stewie-10`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-11': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-11`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-12': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      props: {
        id: `4936838`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-hotjar-12`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-vwo-13': {
      name: `Vwo`,
      from: `@magalu/ecomm-components/rave/scripts/Vwo`,
      id: `header-vwo-13`,
      props: {
        id: `752930`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-14': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-loader-14`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-15': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-state-loader-15`,
      spacing: {
      },
      ssr: false,
    },
    'header-ads-banner-16': {
      name: `AdsBanner`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/AdsBanner`,
      props: {
        className: raveIf([
          props?.route?.deviceInfo?.type,
          `h-[64px]`,
          `h-[44px] w-[1365px]`,
        ]),
        hasBorder: false,
        containerClassName: `bg-brand-darker`,
        slot: raveIf([
          props?.route?.deviceInfo?.type,
          `msite_home_Promo_hypertop`,
          `desk_hypertop_Ads_small`,
        ]),
        device: raveIf([
          props?.route?.deviceInfo?.type,
          `mobile`,
          `desktop`,
        ]),
        channel: raveIf([
          props?.route?.deviceInfo?.type,
          `msite`,
          `web`,
        ]),
        screenName: props?.route?.name,
        position: 1,
        page: props?.route?.name,
        size: `small`,
        placeholder: {
          className: `w-full bg-brand-default`,
          enabled: false,
          height: raveIf([
            props?.route?.deviceInfo?.type,
            `64px`,
            `44px`,
          ]),
        },
      },
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-ads-banner-16`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-header-17': {
      name: `Header`,
      from: `@magalu/ecomm-components/rave/Header`,
      props: {
        cartUrl: props?.data?.platform?.cart?.host,
        topCategories: {
          categoryIds: [
            `TE`,
            `ET`,
            `ED`,
            `MO`,
            `IN`,
            `MD`,
          ],
          limit: 6,
          showAllDepartments: true,
        },
        showTrends: raveExp({
          '===': [
            props?.route?.cookies?.toggle_header_trends,
            `true`,
          ],
        }),
        showBasketCount: raveExp({
          '===': [
            props?.route?.cookies?.toggle_header_basket_counter,
            `true`,
          ],
        }),
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-header-17`,
      spacing: {
      },
      ssr: true,
    },
    'header-event-page-view-dispatcher-18': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-18`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-seller-chat-19': {
      name: `SellerChat`,
      from: `@magalu/ecomm-components/rave/SellerChat`,
      props: {
        item: props?.data?.item,
        nextCartUrl: props?.route?.asPath,
        sellerId: props?.route?.query?.sellerId,
        sellerPage: props?.data?.sellerPage,
        userInfo: props?.data?.userInfo,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-seller-chat-19`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-14-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-loader-14-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-15-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-state-loader-15-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-header-17-children-showcase-0': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        className: ``,
        includePagination: true,
        pageId: `OR0Ks50ePk`,
        placeId: `S28Y67qYld`,
        showcaseId: `3344`,
        salesChannelId: raveIf([
          props?.route?.deviceInfo?.type,
          `9`,
          `45`,
        ]),
      },
      show: raveExp({
        '&&': [
          {
            '!': props?.route?.deviceInfo?.type,
          },
          {
            '===': [
              props?.route?.cookies?.toggle_trending_showcase,
              `true`,
            ],
          },
        ],
      }),
      displayCondition: `show`,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-header-17-children-showcase-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-header-17-children-showcase-1': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        className: ``,
        includePagination: true,
        pageId: `yWHOjTQqKA`,
        placeId: `nED9X6vJno`,
        showcaseId: `3345`,
        salesChannelId: raveIf([
          props?.route?.deviceInfo?.type,
          `9`,
          `45`,
        ]),
      },
      show: raveExp({
        '&&': [
          {
            '!!': props?.route?.deviceInfo?.type,
          },
          {
            '===': [
              props?.route?.cookies?.toggle_trending_showcase,
              `true`,
            ],
          },
        ],
      }),
      displayCondition: `show`,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `header-header-17-children-showcase-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-ads-fetcher-0': {
      name: `AdsFetcher`,
      from: `@magalu/ecomm-components/features/ads/components/AdsFetcher`,
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-ads-fetcher-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col px-md items-center bg-surface-container-lowest`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-row-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        as: `h1`,
        title: `Oops!`,
        className: `font-2xlg-bold mt-sm mx-xsm text-on-interaction-default-inverted`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-row-1-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1-children-heading-1': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `ALGUMA COISA DEU ERRADO`,
        as: `p`,
        className: `font-lg-bold m-xsm text-on-surface-4`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-row-1-children-heading-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1-children-heading-2': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Esta página não está disponível agora. Mas não se preocupe! Tente de novo em alguns instantes. =)`,
        as: `p`,
        className: `font-2xsm-regular m-xsm w-[230px] text-center text-on-surface-5`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-row-1-children-heading-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1-children-image-3': {
      name: `Image`,
      from: `@magalu/ecomm-components/components/Image`,
      props: {
        src: `https://wx.mlcdn.com.br/site/shared/error/error.png`,
        width: `186`,
        height: `186`,
        alt: `imagem indicando erro no site magazineluiza`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-row-1-children-image-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1-children-button-4': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        pushToSiteDomain: true,
        href: `/`,
        label: `VOLTAR PARA O INÍCIO`,
        as: `a`,
        className: `font-2xsm-regular mb-lg mt-sm`,
        size: `large`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `content-row-1-children-button-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-0': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      props: {
        gutterBottom: raveIf([
          raveExp({
            '==': [
              props?.route?.id,
              `product`,
            ],
          }),
          true,
          false,
        ]),
      },
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `footer-back-to-top-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'footer-footer-1': {
      name: `Footer`,
      from: `@magalu/ecomm-components/rave/Footer`,
      props: {
        as: `div`,
        extraContent: {
          links: [
            {
              title: `Magalu`,
              links: [
                {
                  text: `Quem somos`,
                  href: `https://ri.magazineluiza.com.br/show.aspx?idCanal=urUqu4hANldyCLgMRgOsTw==`,
                },
                {
                  text: `Nossas lojas`,
                  href: `https://lojas.magazineluiza.com.br/`,
                },
                {
                  text: `Trabalhe conosco`,
                  href: `https://carreiras.magazineluiza.com.br/`,
                },
                {
                  text: `Programa ouro`,
                  href: `https://especiais.magazineluiza.com.br/dia-de-ouro/`,
                },
                {
                  text: `Assessoria de imprensa`,
                  href: `https://ri.magazineluiza.com.br/show.aspx?idCanal=Zkqmz6KAKUXGYIsGZCxxhg==`,
                },
                {
                  text: `Investidores`,
                  href: `https://ri.magazineluiza.com.br/`,
                  gap: `12px`,
                  img: {
                    src: `https://wx.mlcdn.com.br/site/desk/footer/flag-brasil.svg`,
                    className: `w-4 h-4 inline-block object-contain`,
                    alt: `Flag Bandeira Brasil`,
                  },
                },
                {
                  text: `Investors`,
                  href: `https://ri.magazineluiza.com.br/Default.aspx?idioma=enu&linguagem=en#`,
                  gap: `12px`,
                  img: {
                    src: `https://wx.mlcdn.com.br/site/desk/footer/flag-usa.svg`,
                    className: `w-4 h-4 inline-block object-contain`,
                    alt: `Flag Bandeira USA`,
                  },
                },
              ],
            },
            {
              title: `Para sua empresa`,
              links: [
                {
                  text: `Compre online aqui`,
                  href: `https://www.magaluempresas.com.br/`,
                },
                {
                  text: `Nossas soluções`,
                  href: `https://institucional.magaluempresas.com.br/`,
                },
                {
                  text: `Vendas corporativas`,
                  href: `https://institucional.magaluempresas.com.br/magalu-empresas`,
                },
                {
                  text: `Incentivo e fidelidade`,
                  href: `https://institucional.magaluempresas.com.br/incentivo-e-fidelidade`,
                },
                {
                  text: `Programas de benefício`,
                  href: `https://institucional.magaluempresas.com.br/programa-beneficios`,
                },
                {
                  text: `Catalogo para e-commerce`,
                  href: `https://institucional.magaluempresas.com.br/catalogo-ecommerce`,
                },
                {
                  text: `Televendas corporativas`,
                  href: `https://institucional.magaluempresas.com.br/televendas-corporativas`,
                },
              ],
            },
            {
              title: `Atendimento`,
              links: [
                {
                  text: `Atendimento`,
                  href: `https://atendimento.magazineluiza.com.br/hc/pt-br/`,
                },
                {
                  text: `Termo de compra e venda`,
                  href: `https://especiais.magazineluiza.com.br/termo-compra-venda/`,
                },
                {
                  text: `Arrependimento ou desistência`,
                  href: `https://atendimento.magazineluiza.com.br/hc/pt-br/articles/13163210012557-Como-saber-o-motivo-que-o-meu-pedido-se-enquadra-para-devolu%C3%A7%C3%A3o`,
                },
                {
                  text: `Trocas e devoluções`,
                  href: `https://atendimento.magazineluiza.com.br/hc/pt-br/sections/32335645505933`,
                },
                {
                  text: `Assistência técnica dos fabricantes`,
                  href: `https://atendimento.magazineluiza.com.br/hc/pt-br/articles/32278724887309-Qual-o-contato-do-fabricante-do-meu-produto`,
                },
                {
                  text: `Política de privacidade`,
                  href: `https://especiais.magazineluiza.com.br/politica-de-privacidade/`,
                },
                {
                  text: `Regulamentos`,
                  href: `https://especiais.magazineluiza.com.br/regulamentos/`,
                },
              ],
            },
            {
              title: `Seja nosso parceiro`,
              links: [
                {
                  text: `Venda seus produtos`,
                  href: `https://universo.magalu.com/`,
                },
                {
                  text: `Seja influenciador Magalu`,
                  href: `https://www.magazinevoce.com.br/`,
                },
                {
                  text: `Proteção de marcas`,
                  href: `https://especiais.magazineluiza.com.br/protecao-de-marcas/`,
                },
                {
                  text: `Portal financeiro`,
                  href: `https://www.accesstage.com.br/PortalFinanceiro/login.jsf`,
                },
              ],
            },
          ],
          certificates: [
            {
              href: `https://www.compreconfie.com.br/100515`,
              img: {
                src: `https://selo.compreconfie.com.br/reputation/100515.png`,
                className: `max-h-[54px]`,
                alt: `Selo Compre & Confie`,
              },
            },
            {
              href: `http://www.ebit.com.br/552/selo`,
              img: {
                src: `https://newimgebit-a.akamaihd.net/ebitBR/selo/img_552.png`,
                className: `max-h-[43px]`,
                alt: `Inativa`,
              },
            },
            {
              href: `https://www.magazineluiza.com.br/estaticas/seguranca-maxima/`,
              icon: {
                id: `service-house-security`,
                text: `Certificados e segurança`,
              },
            },
          ],
        },
        topLinks: [
          {
            text: `Blog da Lu`,
            href: `https://www.magazineluiza.com.br/blog-da-lu/`,
          },
          {
            text: `Nossas lojas`,
            href: `https://lojas.magazineluiza.com.br/`,
            rel: `noopener`,
          },
          {
            text: `WhatsApp da Lu`,
            href: `https://wa.me/+5511974627106/`,
            deviceOnly: `mobile`,
            rel: `noopener`,
          },
          {
            text: `Tenha sua loja`,
            href: `https://www.influenciadormagalu.com.br/`,
            rel: `noopener`,
          },
          {
            text: `Regulamento`,
            href: `https://especiais.magazineluiza.com.br/regulamentos/`,
            rel: `noopener`,
          },
          {
            text: `Acessibilidade`,
            href: `https://especiais.magazineluiza.com.br/acessibilidade/`,
            rel: `noopener`,
          },
          {
            text: `Segurança e Privacidade`,
            href: `https://especiais.magazineluiza.com.br/seguranca/`,
            rel: `noopener`,
          },
        ],
        middleContent: [
          `Preços e condições de pagamento exclusivos para compras via internet, podendo variar nas lojas físicas. Ofertas válidas na compra de até 5 peças de cada produto por cliente, até o término dos nossos estoques para internet. Caso os produtos apresentem divergências de valores, o preço válido é o da sacola de compras.`,
          `O Magazine Luiza atua como correspondente no País, nos termos da Resolução CMN nº 4.935/2021, e encaminha propostas de cartão de crédito e operações de crédito para a Luizacred S.A Sociedade de Crédito, Financiamento e Investimento inscrita no CNPJ sob o nº 02.206.577/0001-80.`,
          [
            {
              icon: `chat`,
              text: `Compre pelo chat`,
              href: `https://atendimento.magazineluiza.com.br/hc/pt-br?open=chat_televendas`,
            },
            {
              text: [
                `ou compre pelo telefone:`,
                `0800 773 3838`,
              ],
              className: `text-center font-xsm-medium`,
            },
          ],
        ],
        aboutTheCompany: `Magazine Luiza S/A - CNPJ: 47.960.950/1088-36 - Endereço: Rua Arnulfo de Lima, 2385 - Vila Santa Cruz, Franca/SP - CEP 14.403-471 ® Magazine Luiza – Todos os direitos reservados.`,
      },
      csr: false,
      displayCondition: null,
      hasComponentErrorBoundary: true,
      hasSpacing: false,
      id: `footer-footer-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "serverDefaultOptions": {
      "query": {
        "errorPolicy": "all",
        "fetchPolicy": "no-cache"
      }
    }
  },
  "dataSourceDir": "/src/datasource"
}

export const getHeadProps = (props) => ({
    links: [
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `${props?.clientConfig?.tomURL}/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `${props?.clientConfig?.tomURL}/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        rel: `shortcut icon`,
        href: `https://site-content.magazineluiza.com.br/static/img/default/favicon-cc4cf323.png`,
      },
      {
        rel: `shortcut icon`,
        type: `image/ico`,
        href: `https://site-content.magazineluiza.com.br/static/img/default/favicon-cc4cf323.png`,
      },
    ],
    meta: [
      {
        name: `format-detection`,
        content: `telephone=no`,
      },
      {
        name: `description`,
        content: `Confira as ofertas do dia no site do Magazine Luiza. Encontre promoções imperdíveis em eletrônicos, móveis, eletrodomésticos e muito mais. Compre online com segurança e receba no conforto da sua casa.`,
      },
    ],
    title: `Magazine Luiza | Pra você é Magalu!`,
  });

export const componentsList = [
  "Button",
  "Preconnect",
  "GoogleTagManager",
  "Script",
  "AllIn",
  "Criteo",
  "Bing",
  "CookieSecurity",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Vwo",
  "Loader",
  "StateLoader",
  "AdsBanner",
  "Header",
  "EventPageViewDispatcher",
  "SellerChat",
  "PageLoading",
  "Showcase",
  "AdsFetcher",
  "Row",
  "Heading",
  "Image",
  "BackToTop",
  "Footer"
];

export const routeInfo = {
  id: '500',
  name: 'internal-error-page',
  pathPattern: '/error-500',
  pathAliases: {},
  parser: {
    query: {
      "page": numberParser(),
      "categoryId": uppercaseParser(),
      "subCategoryId": uppercaseParser(),
      "seller_id": arrayShiftParser(),
    },
    cookie: {
      "ml2_sid_c": encodedObjectParser(),
    },
  },
  renderMethod: 'SSG',
  forwardCookies: 'toggle_enable_product_review,toggle_show_luiza_installment_plan,ml_exp',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for,theme'
};

export const manifest = {
  "useTypescript": true,
  "useComponentErrorBoundary": true
};

export const getGlobalClassName = props => ([
    raveExp({
      '??': [
        props?.route?.headers?.theme,
        ``,
      ],
    }),
  ]).join(' ').trim();

export const getPageVariables = props => ({
  });

export const middlewaresArgs = ({ 
      "getUserInfo": (props) => ({
  }),
      "brandsResolver": (props) => ({
    limit: 100,
  }),
      "getPlatformEnvs": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "getContextualSearchParams": (props) => ({
  }),
 });

export const config = {
  assetPrefix: 'https://wx.mlcdn.com.br/mixer-web/static/v1.201.1',
};
